import React from 'react';
import { NavigationProp, RouteProp, useNavigation } from '@react-navigation/native';
import { useForm } from 'react-hook-form';
import FilterModal from '../../../components/ModernFilters/FilterModal';
import CameraTagList from '../../../components/ModernFilters/cameras/CameraTagList';
import { translate } from '../../../services/translate';
import { CamerasParamList } from '../../../typings/Params';

interface Props {
    filters: CamerasParamList['AlertGroups'];
    setFilters: React.Dispatch<React.SetStateAction<CamerasParamList['AlertGroups']>>;
    textFilter: string;
    setTextFilter: React.Dispatch<React.SetStateAction<string>>;
}

type FiltersForm = {
    cameraTagIds: number[];
};

function Filter({ filters, setFilters, textFilter }: Props) {
    const navigation = useNavigation<NavigationProp<RouteProp<CamerasParamList, 'AlertGroups'>>>();
    const form = useForm<FiltersForm>({
        mode: 'onChange',
        defaultValues: {
            cameraTagIds: filters.cameraTagIds ?? [],
        },
    });

    const handleFilter = (values: FiltersForm) => {
        const params = {
            textFilter: textFilter !== '' ? textFilter : undefined,
            cameraTagIds: values.cameraTagIds.length ? values.cameraTagIds : undefined,
        };

        setFilters({ ...filters, page: 0, ...params });
        navigation.setParams({ ...filters, page: 1, ...params });
    };

    return <FilterModal
        form={form}
        onFilters={handleFilter}
        cleanValues={{ cameraTagIds: [] }}
        filters={[{
            label: translate('cameraInfoLabel'),
            filters: [{
                componentHandlesCount: true,
                name: 'cameraTagIds',
                label: translate('cameraTags'),
                component: CameraTagList,
            }],
        }]}
    />;
}

export default Filter;
